<template>
  <div class="mt-8">
    <template v-if="tableList&&tableList.length>0">
      <el-table
          height="300"
          :data="tableList"
          class="w-100">
        <el-table-column
            width="130px"
            prop="orderid"
            :label="$t('friends.orderid')">
        </el-table-column>
        <el-table-column
            width="130px"
            prop="useremail"
            :label="$t('friends.useramount')">
        </el-table-column>
        <el-table-column
            width="130px"
            prop="sku.goodsSpu.goodsname"
            :label="$t('friends.sku')">
        </el-table-column>
        <el-table-column
            width="150px"
            prop="sku.skuname"
            :label="$t('friends.duration')">
        </el-table-column>
        <el-table-column
            width="150px"
            prop="type"
            :label="$t('friends.promotiontype')">
          <template v-slot="scope">
            {{ filterObj(typeOptions,'value',scope.row.type).label }}
          </template>
        </el-table-column>
        <el-table-column
            width="150px"
            prop="status"
            :label="$t('friends.status')">
          <template v-slot="scope">
            {{ filterObj(comstatusOptions,'value',scope.row.status).label }}
          </template>
        </el-table-column>
        <el-table-column
            width="150px"
            prop="price"
            :label="$t('friends.orderamount')">
        </el-table-column>
        <el-table-column
            width="150px"
            prop="profit"
            :label="$t('friends.eainings')">
        </el-table-column>
        <el-table-column
            width="150px"
            prop="createTime"
            :label="$t('friends.createtime')">
        </el-table-column>
      </el-table>
      <div class="large tr mt-2">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
      <div class="small tr mt-2">
        <el-pagination
            @currenct-change="handleCurrentChange"
            :current-page="page"
            small
            layout="prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </template>
    <!-- 暂无数据-->
    <div v-else class="empty">
      <img :src="`${$g.imgPrefix}/img/common/no-result.webp`">
      <div class="empty-text">{{$t('friends.nodata')}}</div>
    </div>
  </div>
</template>

<script>
import {
  filterObj,
  MessageError
} from "@/util/util"
import {
  getCommissionList
} from "@/request/requests"
export default {
  name: "promotionList",
  data() {
    let typeOptions = [
      {
        value: "1",
        // label: "판촉 링크"
        // label: "Promotion link"
        label: this.$t('friends.promotionlink'),
      },
      {
        value: "2",
        // label: "할인 코드"
        // label: "Discount code"
        label: this.$t('friends.discountcode'),
      }
    ];
    let comstatusOptions = [
      {
        value: "1",
        // label: "正常"
        // label: "표준"
        label: this.$t('friends.normal'),
      },
      {
        value: "0",
        // label: "无效"
        // label: "무효"
        label: this.$t('friends.invalid'),
      },
    ]
    return {
      typeOptions,
      comstatusOptions,
      tableList: [],
      page: 1,
      size: 10,
      total: 0,
      screenWidth: null,
      userInfo:{}
    }
  },
  methods: {
    filterObj,
    getData(userInfo,timeList) {
      this.userInfo = userInfo;
      let params = {
        size: this.size,
        page: this.page,
        reuserid: this.userInfo.id,
        starttime: this.$moment(timeList[0]).format('yyyy-MM-DD'),
        endtime: this.$moment(timeList[1]).format('yyyy-MM-DD')
      }
      return new Promise((resolve,reject)=>{
        getCommissionList(this.$qs.stringify(params)).then(res=>{
          if (res.status === "200") {
            this.tableList = res.data?.list;
            this.total = res.data?.total;
            resolve();
          } else {
            MessageError(res.msg);
            reject();
          }
        })
      })
    },
    handleSizeChange(val) {
      this.size = val;
      this.page = 1;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.size = val;
      this.getTableList();
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    }

  },
  mounted(){
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },

}
</script>

<style lang="scss" scoped>
.empty{
  margin-top:100px;
  display:flex;
  flex-direction: column;
  align-items: center;
  img{
    width:200px;
  }
  @media(max-width:576.98px){
    margin-top:revert;
  }
}
</style>